import BaseAgencyScopeEntityDto from "@/models/Shared/BaseAgencyScopeEntityDto";
import CompanyDto from "@/models/Companies/CompanyDto";

export default class BaseCompanyScopeEntityDto extends BaseAgencyScopeEntityDto {
    companyId: string;
    company: CompanyDto = new CompanyDto();
}